import * as angular from "angular";

angular
  .module('bringoz.admin.commons')
  .filter('packageSpots', packageSpots);

function packageSpots() {
  return function packageSpotsFilter(packageRef) {
    let spotsSum;

    if (packageRef && packageRef.items && packageRef.items.length) {
      spotsSum = packageRef.items.reduce((acc, item) => {
        if (item.requiredSpots) {
          acc += (item.requiredSpots * (item.count || 1));
        }
        return acc;
      }, 0);
    }
    return spotsSum;
  }
}
